export default "__VITE_ASSET__BCr9BEsx__"